import React, { FC } from 'react'
import { reduxForm, Field } from 'redux-form'
import { Input } from 'semantic-ui-react'
//@ts-ignore
import LKButton from 'shared/LKButton'
//@ts-ignore
import { ComponentContainer } from 'shared/StyledComponents'

import { AgreementNumberInputWrapperProps } from '../../types.LoanDetails'
import { updateAgreementNumber } from 'src/store/loan'

const getInputOnChange =
  (storeOnChange) =>
  (e, { value }) =>
    storeOnChange(value)

const component = ({ input: { value, onChange } }) => (
  <ComponentContainer input style={{ float: 'left', width: 'auto', marginRight: 5 }}>
    <Input value={value} onChange={getInputOnChange(onChange)} />
  </ComponentContainer>
)

const formContainer = reduxForm({
  destroyOnUnmount: false,
  onSubmit: ({ agreementNumber }, dispatch, { ID, hash, formName }) => {
    return new Promise<void>((resolve, reject) => {
      // dispatch(
      //   fetchSFM({
      //     instanceName: formName,
      //     callApi: Loan.updateAgreementNumber,
      //     callApiArgs: [agreementNumber, ID, hash],
      //     resolve,
      //     reject,
      //   }),
      // )

      //UPDATED API REQUEST loan_oper_api page: agreementnumberupdate
      dispatch(
        updateAgreementNumber({
          LoanID: ID,
          HashSum_LoanID_: hash,
          AgreementNo: agreementNumber,
        }),
      )
        .then((response) => {
          if (!updateAgreementNumber.fulfilled.match(response)) {
            reject()
            throw { Error: { Message: response.payload } }
          }
          resolve()
        })
        .catch(() => {
          reject()
        })
    })
  },
})

const AgreementNumberInput = formContainer(({ handleSubmit }) => (
  <form onSubmit={handleSubmit}>
    <Field name="agreementNumber" component={component} />

    <LKButton onClick={handleSubmit} alias="save" permission="EDIT_AGREE_LOAN" />
  </form>
))

const AgreementNumberInputWrapper: FC<AgreementNumberInputWrapperProps> = (props) => {
  const { ID, initialValue } = props
  const key = `LoanDetailsOther-${ID}-AgreementNumberInput`

  return <AgreementNumberInput {...props} initialValues={{ agreementNumber: initialValue }} form={key} formName={key} />
}

export default AgreementNumberInputWrapper
